import { Injectable } from '@angular/core';
import { FilterSelection } from '@app/core/classes/filterSelection';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { FilterActions } from './filter.actions';

export class FilterStateModel {
  public filter: FilterSelection

}

const defaults = {
  filter: new FilterSelection()
};

@State<FilterStateModel>({
  name: 'filter',
  defaults
})
@Injectable()
export class FilterState {
  site: string;

  constructor(
  ) { 

  }

  @Selector()
  static token(state: FilterStateModel): FilterSelection {
    return state.filter;
  }

  @Action(FilterActions.Filters)
  login(ctx: StateContext<FilterStateModel>, { filter }: FilterActions.Filters) {
        ctx.patchState({
            filter: filter
        });
  }

}
